import React, { useEffect } from 'react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import './SlightestMe.scss';
import { illustration } from '../../assets/Assets';
import { useHistory } from 'react-router-dom';

gsap.registerPlugin(ScrollTrigger);

function SlightestMe() {
  useEffect(() => {
    let tl = gsap.timeline({
      ease: 'power0',
      scrollTrigger: {
        trigger: '.slightestMe button',
        start: 'top 75%',
        end: 'bottom 25%',
        toggleActions: 'play',
      },
    });

    tl.from('.slightestMe img', {
      duration: 1,
      scale: 0.8,
      opacity: 0.2,
      y: 40,
      ease: 'power0',
    })
      .from('.slightestMe h1', { duration: 1, y: '-14vw' }, '<.5')
      .from(
        '.slightestMe button',
        { duration: 1, scale: 0.8, ease: 'none', opacity: 0 },
        '<.1'
      );
  }, []);

  const history = useHistory();
  return (
    <section className="slightestMe">
      <div className="box">
        <h1>
          Little things about me <hr />
        </h1>
      </div>

      <article>
        <img src={illustration} alt="" />
        <div>
          <h2 id="slightestMe">Know me better</h2>
          <p>
            I am just a blogger who kinda curious about all things happened
            behind the scene. I've been code since last month of 2020 and found
            it so exciting.
          </p>
          <button
            className="trigger"
            onClick={() => {
              history.push('/about');
              window.scrollTo(0, 0);
            }}
          >
            More About Me
          </button>
        </div>
      </article>
    </section>
  );
}

export default SlightestMe;
